
import { Mixins, Component, Ref, Prop, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { Form } from "element-ui/types";
import { getHourDetailById, editHourDetail } from "@/api/twoHour";

@Component({ components: {} })
export default class twoHourEditDialog extends Mixins(loading) {
  @Ref("validateForm") validateForm: Form;
  @Prop([Boolean]) private dialogVisible!: boolean;
  @Prop([Number]) private id!: number;

  formData = {
    time: "",
    name: "",
    matchViscera: "",
    goodTry: "",
    badTry: "",
    introduction: "",
    remark: "",
  };

  dialogClose() {
    this.validateForm?.resetFields();
    this.$emit('closeEditDialog');
  }

  saveAppUpdate() {
    this.validateForm?.validate().then((valid) => {
      if (valid) {
        const params = {
          ...this.formData,
          time: undefined
        }
        this.showLoading();
        editHourDetail(params).then((res) => {
            this.$message.success("保存成功");
            this.$emit('editDialogConfirm');
        }).finally(() => {
            this.hideLoading();
        })
      }
    })
  }

  @Watch("dialogVisible", { immediate: true })
  getData() { 
    if(this.dialogVisible != true) return;
    getHourDetailById({ id: this.id }).then((res) => {
      this.formData = res.data || [];
      const startTime = res.data.startTime.slice(0, 5);
      const endTime = res.data.endTime.slice(0, 5);
      this.formData.time = startTime + " - " + endTime;
    })
  }
}
